// @flow
import {REHYDRATE} from 'redux-persist';
import config from '../../config/index';
import I18n from '../../lib/i18n';
import type {LocalizationAction} from './actions';

export type LocalizationStateType = {|
  locale: string,
|};

const initialState: LocalizationStateType = {
  locale: I18n.locale,
};

const updateLocale = locale => {
  const safeLocale = config.locales.includes(locale)
    ? locale
    : config.locales[0];
  I18n.locale = safeLocale;

  return safeLocale;
};

export const localizationReducer = (
  state: LocalizationStateType = initialState,
  action: LocalizationAction,
) => {
  switch (action.type) {
    case 'SET_LOCALE':
      const updatedLocale = updateLocale(action.payload.locale);
      return {
        ...state,
        locale: updatedLocale,
      };
    case REHYDRATE:
      // $FlowFixMe
      if (action.payload) {
        const incoming = action.payload.localization;
        if (incoming) {
          const incomingLocale = updateLocale(incoming.locale);
          return {
            ...state,
            locale: incomingLocale,
          };
        }
      }
      return state;
    default:
      return state;
  }
};
